module.exports = __webpack_public_path__ + "static/media/mrs-training-logo.cf98ccc6.svg";